import React from 'react';
import styled from 'styled-components';
import { utils } from '@makeship/core';
import { Label } from '../../ui/typography';

const CartQuantityWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CartQuantityButton = styled.button<{ disabled: boolean }>`
  width: 20px;
  height: 20px;
  background-color: ${({ theme, disabled }) =>
    disabled ? utils.hexToRGBA(theme.colors.neutral7, theme.alpha.dark) : 'var(--color-zinc-900)'};
  color: ${({ theme }) => theme.colors.neutral1};
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  cursor: pointer;
  &:active,
  :focus,
  :focus-visible {
    outline: none;
  }
`;

type StepperProps = {
  value: number;
  increase: () => void;
  decrease: () => void;
  isLimited?: boolean;
  isLimitedQtyOutOfStock?: boolean;
};

const Stepper: React.FC<StepperProps> = ({
  value,
  increase,
  decrease,
  isLimited,
  isLimitedQtyOutOfStock,
}: StepperProps) => (
  <CartQuantityWrapper>
    <CartQuantityButton onClick={decrease} disabled={false}>
      <Label color="primary-white">-</Label>
    </CartQuantityButton>
    <div className="mx-4">
      <Label size="large">{value}</Label>
    </div>
    {isLimited && isLimitedQtyOutOfStock ? (
      <CartQuantityButton onClick={increase} disabled>
        <Label color="primary-white">+</Label>
      </CartQuantityButton>
    ) : (
      <CartQuantityButton onClick={increase} disabled={false}>
        <Label color="primary-white">+</Label>
      </CartQuantityButton>
    )}
  </CartQuantityWrapper>
);

export default Stepper;
